/* eslint-disable react/jsx-no-useless-fragment */
/* eslint-disable react/jsx-key */
import React, { useEffect, useMemo, useState } from 'react';
import { Box, Link, Grid, Stack, Divider, Popover, Typography, IconButton, Button, Modal } from '@mui/material';
import _ from 'lodash';
import moment from 'moment';
import {
  lockIcon,
  getBorderColor,
  getTrophyBadge,
  // formatNumberWithCommas,
  GroupBasedRoleFormatter,
  getGoalProgressShowOrNot,
  meetingColor,
  timeZoneWiseTime,
  formattedTimeSlot,
  timeZoneAbbreviation,
  timeZonWiseDateTime,
  checkCallType
} from '../../components/common';
import { UserIcon, EditIcon, ChatIcon, DeleteIcon, VideoCallIcon, PlusCircleIcon } from '../../../../utils/Icons';
// import MyPeers from './MyPeers';
// import AvatarRow from './Avatars';
import { API } from '../../../../api';
import { toast } from 'react-toastify';
// import NewTaskCard from './NewTaskCard';
import {
  // dummyAvatar,
  dummyMyMentorsList
} from '../../../../utils/dummyLoadingData';
import WelcomeModals from './WelcomeModals';
import ProgressChart from './ProgressChart';
import { useAuth0 } from '@auth0/auth0-react';
import UserPeersPopup from './UserPeersPopup';
import Leaderboard from './cards/Leaderboard';
import { useNavigate } from 'react-router-dom';
import MenteeTaskPopup from './MenteeTaskPopup';
import MyMentorSection from './MyMentorSection';
import TaskCardSection from './TaskCardSection';
import YourNextMetting from './YourNextMetting';
import RecruitNewMentor from './RecruitNewMentor';
import GettingStartedCard from './GettingStartedCard';
import { useQueryClient } from '@tanstack/react-query';
import GettingStartedModal from './GettingStartedModal';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import ArrowBackIosNewOutlinedIcon from '@mui/icons-material/ArrowBackIosNewOutlined';
import ArrowForwardIosOutlinedIcon from '@mui/icons-material/ArrowForwardIosOutlined';
import CheckOutlinedIcon from '@mui/icons-material/CheckOutlined';
import AddIcon from '@mui/icons-material/Add';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import FlagOutlinedIcon from '@mui/icons-material/FlagOutlined';
import QuestionAnswerOutlinedIcon from '@mui/icons-material/QuestionAnswerOutlined';
import RestoreIcon from '@mui/icons-material/Restore';
import InsertInvitationOutlinedIcon from '@mui/icons-material/InsertInvitationOutlined';
import CloseIcon from '@mui/icons-material/Close';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import { useModule } from '../../../../utils/useModule';
import { levelTypes } from '../../../../utils/constants';
import MySkeleton from '../../../../components/Skeleton';
import { queryKeys } from '../../../../queries/queryKeys';
import { getUserDetails } from '../../../../utils/orgName';
import useMyMentors from '../../../../queries/useMyMentors';
import { useUserRole } from '../../../../utils/useUserRole';
import { CardStyle } from '../../style-components/CardStyling';
// import community from '../../../../assets/images/directory.svg';
import useMenteePeers from '../../../../queries/useMenteePeers';
import DescriptionModal from '../../components/DescriptionModal';
import MeetingDetails from './MeetingDetails';
import useLearningObjs from '../../../../queries/useLearningObjs';
import useGroupDetails from '../../../../queries/useGroupDetails';
import useGoalProgress from '../../../../queries/useGoalProgress';
import PreviewContent from '../Program/components/PreviewContent';
// import CheckInWithMentorDialog from './CheckInWithMentorDialog';
import useProfileDetails from '../../../../hooks/useProfileDetails';
import useAllGroupTasks from '../../../../queries/useAllGroupTasks';
import { GetTasksLoader } from '../../../../Loader/MenteeHomeLoader';
import greycheckimg from '../../../../assets/images/greycheckimg.svg';
import { getOrfiumLevelName } from '../../../../utils/orfiumFunctions';
import greencheckimg from '../../../../assets/images/greencheckimg.svg';
import { useAppDispatch, useAppSelector } from '../../../../redux/hooks';
import useObjectiveProgress from '../../../../queries/useObjectiveProgress';
import { taskActions } from '../../../../redux/slices/goals-tasks/getTasksSlice';
import useResponsiveScreenSwitch from '../../../../utils/useResponsiveScreenSwitch';
import { menteeTaskSlicAction } from '../../../../redux/slices/user-task/userMenteeTask';
import { chatProfileActions } from '../../../../redux/slices/chat-profile/chatProfileSlice';
import { updateXpPoints } from '../../../../redux/slices/menteeXpPoints/menteeXpPointsSlice';
import { fetchUserWorkHistory } from '../../../../redux/slices/user-work/userWorkHistorySlice';
import { fetchUserEducation } from '../../../../redux/slices/user-education/userEducationSlice';
import { fetchCommunityMembers } from '../../../../redux/slices/acs-community-members/acsCommunityMembers';
import MenteeMasterclass from './MenteeMasterclass';

const Mentee = () => {
  const selectedGroupId = useAppSelector((state) => state.selectedGroup.data);
  const queryClient = useQueryClient();
  const { isMentee } = useUserRole();
  const mentorRoleText =
    selectedGroupId.id === '64fa3b0ef3cbc20ba20de466' ? 'Matches' : GroupBasedRoleFormatter('mentor', 'Mentors');
  const { user } = useAuth0();
  const { location, orgId, userId: currentUserId } = getUserDetails();
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const classess = CardStyle();
  const selectedUserId = useAppSelector((state) => state.goalTasks.userId);
  const { gettingStarted, objectivesNumber, timezone } = useProfileDetails();
  const { isMasterclass, isMentorship, isHybrid } = useModule(); // Fetching module from Redux state
  const {
    refetch,
    isFetching,
    isLoading,
    data: newData,
    isStale
  } = useAllGroupTasks(selectedGroupId.id, selectedUserId);
  const goalProgress = useGoalProgress(newData?.data?.data[0]?.levels || []);
  const [selectedMember, setSelectedMember] = useState<any>(null);

  const [xpPoints, setXpPoints] = useState<any>();

  /** Getting Started Modal */
  const [openGettingStartedModal, setOpenGettingStartedModal] = useState(false);
  const [selectedStep, setSelectedStep] = useState(0);
  const handleClickGettingStartedModal = (flag: boolean) => {
    setOpenGettingStartedModal(flag);
  };

  /** Welcome Modals */

  /** Check In With Mentor modal */
  // const [checkInWithMentor, setOpenCheckInWithMentor] = useState(true);
  // const handleCheckInWithMentor = (flag: boolean) => { setOpenCheckInWithMentor(flag) };

  const [goalProgressValue, setGoalProgressValue] = useState(0);
  const personalThreadsArr = useAppSelector((state) => state.acsChannels.personalThreadsArr);
  const [displayName, setDisplayName] = useState('');
  const [participantUser, setParticipantUser] = useState([]);
  const [reloadFlag, setReloadFlag] = useState(false);
  const communityMembers = useAppSelector((state) => state.acsCommunityUsers.data);
  const commList = useAppSelector((state) => state.getCommunityMembers.data);
  const groupId = selectedGroupId.id || '';
  const menteeTask = useAppSelector((state) => state?.goalTasks);
  const taskLoading = isLoading;
  const [taskData, setTaskData] = useState<any>([]);
  const { loading: loadingGoal, data: userGoals } = useAppSelector((state) => state.groupDetails) || {};
  const goalCount = Object.keys(userGoals?.goals ? userGoals?.goals : {}).length;
  const [editModalOpen, setEditModalOpen] = React.useState(false);
  const groupDetails = useAppSelector((state) => state?.groupDetails);
  /** Show goal progress */
  const [hasShowGoalProgressValue, setHasShowGoalProgressValue] = useState<any>(true);
  const showGoalProgress = getGoalProgressShowOrNot(hasShowGoalProgressValue) || isMentorship;
  /** For responsive */
  const { forMobile } = useResponsiveScreenSwitch(); // Use the hook
  const [isPeersPopupOpen, setPeersPopupOpen] = React.useState(false);
  const oid = useAppSelector((state) => state.orgDetails.data?.oid);
  const [recentlyScheduledMeeting, setRecentlyScheduledMeeting] = useState(null);
  const [activeMeetingModal, setActiveMeetingModal] = useState<{
    type: 'history' | 'future' | null;
    mentor: any | null;
  }>({ type: null, mentor: null });
  const [recruitModalOpen, setRecruitModalOpen] = useState(false);
  const [recruitMentors, setRecruitMentors] = useState<any[]>([]);
  const [recruitMentorsLoading, setRecruitMentorsLoading] = useState(false);
  const [mentorshipProgress, setMentorshipProgress] = useState({
    mentorsEngaged: 0,
    messagesSent: 0,
    meetingsScheduled: 0
  });
  const [currentObjectiveIndex, setCurrentObjectiveIndex] = useState(0);
  const [hasSetObjectiveIndex, setHasSetObjectiveIndex] = useState(false);
  const [markingObjective, setMarkingObjective] = useState(false);
  const [completeModalOpen, setCompleteModalOpen] = useState(false);
  const [cancelMatchModalOpen, setCancelMatchModalOpen] = useState(false);
  const [mentorMenuAnchor, setMentorMenuAnchor] = useState<HTMLElement | null>(null);
  const [mentorMenuData, setMentorMenuData] = useState<any>(null);
  const [mentorToCancel, setMentorToCancel] = useState<any>(null);
  const [mentorCardIndex, setMentorCardIndex] = useState(0);
  const handleMeetingScheduled = (meetingDetails: any) => {
    setRecentlyScheduledMeeting(meetingDetails);
    if (doReload) doReload();
  };
  const {
    data: mentorsData,
    isLoading: mentorLoading,
    refetch: mentorsRefetch
  } = useMyMentors({
    grpId: groupId,
    orgId,
    location: getUserDetails().location
  });
  const {
    data: peersData,
    isLoading: peersLoading,
    refetch: peersRefetch
  } = useMenteePeers({
    grpId: groupId,
    orgId,
    location: getUserDetails().location
  });
  const loader = mentorLoading || peersLoading;

  const handlePeersPopup = (open: boolean) => {
    setPeersPopupOpen(open);
  };
  const handlePeersOpen = (open: boolean) => {
    setPeersPopupOpen(open);
  };

  const doReload = () => {
    queryClient.invalidateQueries({
      queryKey: [queryKeys.GET_MENTEE_PEERS, groupId]
    });
    queryClient.invalidateQueries({
      queryKey: [queryKeys.GET_MY_MENTORS, groupId]
    });
  };
  const updateMeeting = useAppSelector((state) => state.updateMeeting);

  useEffect(() => {
    setRecentlyScheduledMeeting(null);
  }, [updateMeeting]);

  useEffect(() => {
    mentorsRefetch();
  }, [groupId]);

  // const fetchRecruitMentors = async () => {
  //   try {
  //     setRecruitMentorsLoading(true);
  //     const response = await API.getAllObjectiveMentors({
  //       orgId,
  //       grpId: groupId
  //     });
  //     if (response.data) {
  //       setRecruitMentors(response.data.data || []);
  //     }
  //   } catch (error) {
  //     toast.error(_.get(error, 'response.data.message', 'Failed to fetch mentors'));
  //   } finally {
  //     setRecruitMentorsLoading(false);
  //   }
  // };

  const handleRecruitModalOpen = (open: boolean) => {
    setRecruitModalOpen(open);
    // if (open) {
    //   fetchRecruitMentors();
    // }
  };

  const fetchMentorshipProgress = async () => {
    try {
      const response = await API.getMenteeProgress({ orgId, grpId: groupId });
      if (response.data) {
        setMentorshipProgress(response.data.data);
      }
    } catch (error) {
      console.error('Error fetching mentorship progress:', error);
    }
  };

  useEffect(() => {
    if (groupId) {
      fetchMentorshipProgress();
    }
  }, [groupId, reloadFlag]);

  const [isModalOpen, setModalOpen] = useState(false);
  const [levelDescription, setLevelDescription] = useState('');
  const [levelNumber, setLevelNumber] = useState(0);
  const [levelFullName, setLevelFullName] = useState(0);
  const handleOpenDescription = () => {
    setModalOpen(true);
  };
  const handleCloseModal = () => {
    setModalOpen(false);
  };

  const {
    data: objectives,
    isLoading: objLoading,
    refetch: fetchObjectives,
    isError: objError
  } = useLearningObjs({ orgId, grpId: groupId });

  const learningObjectives = objectives?.data?.data || [];
  const objProgress = useObjectiveProgress(objectives?.data?.data || []);

  useEffect(() => {
    fetchObjectives();
  }, [groupId]);

  useEffect(() => {
    setHasSetObjectiveIndex(false);
  }, [groupId]);
  const [selectedLevelId, setSelectedLevelId] = useState<any[]>([]);
  const [selectedLevelName, setSelectedLevelName] = useState('');
  const [rightTopPop, setRightTopPop] = useState(null);
  const rightTopDotsClick = (level: any) => (event: any) => {
    setEditModalOpen(true);
    setSelectedLevelId(level._id);
    setSelectedLevelName(level.levelName);
    setRightTopPop(event.currentTarget);
  };
  const handleClose = () => {
    setRightTopPop(null);
    setEditModalOpen(false);
  };
  const openMoreVerts = Boolean(rightTopPop);
  const rightTopPopover = openMoreVerts ? 'simple-popover' : undefined;
  const avatars = peersData?.data.data[0]?.menteeDetails.map((each: any) => ({
    avatar: each?.headshot,
    firstName: each?.displayName
  }));
  const groupList = useAppSelector((state) => state.groupRoleList);
  const moveToUsercommunityProfile = (userId: string) => {
    const mem = communityMembers.find((item: { userId: string }) => item.userId === userId);
    const modifiedMem = { ...mem, id: _.get(mem, 'id.coId', '') };
    if (mem) {
      navigate('/app/communitymember', {
        state: { mem: modifiedMem, allCommunityMembersList: commList }
      });
    }
  };

  const getMenteesInsights = async () => {
    const menteeInsightsData = await API.getMenteeInsights(orgId, location, groupId);
    if (menteeInsightsData) {
      setXpPoints(menteeInsightsData?.data?.xpPoints);
      dispatch(updateXpPoints(menteeInsightsData?.data?.xpPoints));
      setGoalProgressValue(menteeInsightsData?.data?.goalProgress);
      setHasShowGoalProgressValue(menteeInsightsData?.data?.showGoalProgress);
    }
  };

  const getChannels = () => {
    dispatch(
      fetchCommunityMembers({
        orgId: getUserDetails().orgId,
        location: getUserDetails().location
      })
    );
  };

  const [helpfulTips, setHelpfulTips] = useState([]);
  const [articleData, setArticleData] = useState(null);
  const [openPreview, setOpenPreview] = useState(false);
  const [articleDataLoading, setArticleDataLoading] = useState(false);
  const [mentorshipHoursValue, setMentorshipHours] = useState('00:00');
  const [mentorRoi, setMentorRoi] = useState<any>(0);

  const handelOnClickPreviewArticleName = async (articleId: string, location: string) => {
    setArticleDataLoading(true);
    setOpenPreview(true);
    try {
      const response = await API.getAllArticleById({
        orgId: orgId,
        articleId: articleId,
        isContentSettings: false,
        articleLocation: location ? location : ''
      });
      if (response && response.status === 200) {
        setArticleData(response.data.article);
        setHelpfulTips((prevTips: any) =>
          prevTips.map((tip: any) => (tip._id === articleId ? { ...tip, isRead: true } : tip))
        );
      }
    } catch (error) {
      toast.error(_.get(error, 'response.data.message', 'Something went wrong, please try again'));
      setOpenPreview(false);
    } finally {
      setArticleDataLoading(false);
    }
  };

  const getMenteeHelpfulTips = async () => {
    const response = await API.getHelpfulTips({ groupId: groupId, role: 'mentee', location });
    if (response.status === 200) {
      setMentorshipHours(response?.data?.mentorshipHours);
      const formattedMentorROI = new Intl.NumberFormat('en-US', {
        notation: 'compact',
        maximumFractionDigits: 1
      }).format(response?.data?.mentorROI);

      setMentorRoi(formattedMentorROI);
      setHelpfulTips(response?.data?.data);
    }
  };

  useEffect(() => {
    getMenteeHelpfulTips();
  }, [groupId]);

  useEffect(() => {
    if (groupDetails.data) {
      const allowEditing = groupDetails?.data?.includeTask && groupDetails?.data?.allowEditing ? true : false;
      // if (!gettingStarted.editTasks && allowEditing) {
      //   setOpenGettingStartedModal(true);
      // }
      // if (!gettingStarted.nonEditTasks && !allowEditing) {
      //   setOpenGettingStartedModal(true);
      // }
      if (!gettingStarted) {
        setOpenGettingStartedModal(true);
      }
    }
  }, [groupId, gettingStarted, groupDetails.data]);

  useEffect(() => {
    getChannels();
  }, []);

  useEffect(() => {
    if (menteeTask) {
      setTaskData(newData?.data?.data);
    } else {
      setTaskData([]);
    }
  }, [newData]);

  const { refetch: fetchGroupDetails } = useGroupDetails(groupId, getUserDetails().location);

  useEffect(() => {
    try {
      if (groupId) {
        fetchGroupDetails();
      }
    } catch (error) {}
  }, [groupId]);

  const saveAnswer = useAppSelector((state) => state.saveAnswer.flag);
  useEffect(() => {
    if (isStale && !saveAnswer && !isMentorship) {
      refetch();
    }
  }, [selectedGroupId.id, selectedUserId, saveAnswer, isStale]);

  useEffect(() => {
    if (selectedMember?.userId) {
      dispatch(fetchUserWorkHistory(selectedMember?.userId));
      dispatch(fetchUserEducation(selectedMember?.userId));
    }
    if (groupId) {
      if (isMentee) {
        dispatch(taskActions.setUserId({ userId: '' }));
      }
    }
  }, []);

  const getName = (each: any) => {
    const chatProfileFirstName: any = _.get(each, 'firstName', '');
    const chatProfileLastName: any = _.get(each, 'lastName', '');
    return chatProfileFirstName
      ?.charAt(0)
      ?.toUpperCase()
      ?.concat(chatProfileFirstName?.slice(1)?.toLowerCase())
      ?.concat(
        ' ',
        chatProfileLastName?.charAt(0)?.toUpperCase()?.concat(chatProfileLastName?.slice(1)?.toLowerCase())
      );
  };

  const navigateMember = (member: any) => {
    setSelectedMember(member);
  };

  const handleOpenMentorMenu = (event: React.MouseEvent<HTMLElement>, mentor: any) => {
    setMentorMenuAnchor(event.currentTarget);
    setMentorMenuData(mentor);
  };

  const handleCloseMentorMenu = () => {
    setMentorMenuAnchor(null);
    setMentorMenuData(null);
  };

  const handleViewMentorProfile = (mentor?: any) => {
    const targetMentor = mentor || mentorMenuData;
    if (targetMentor) {
      navigateMember(targetMentor);
    }
    handleCloseMentorMenu();
  };

  const handleOpenMeetingModal = (mentor: any, type: 'history' | 'future') => {
    setActiveMeetingModal({ type, mentor });
  };

  const handleCloseMeetingModal = () => {
    setActiveMeetingModal({ type: null, mentor: null });
  };

  const handleCancelMatchClick = () => {
    setMentorToCancel(mentorMenuData);
    handleCloseMentorMenu();
    setCancelMatchModalOpen(true);
  };

  const handleConfirmCancelMatch = () => {
    // TODO: Integrate actual cancel match API call when available
    const targetName = mentorToCancel ? getMentorDisplayName(mentorToCancel) : 'mentor';
    toast.info(`Cancel match requested for ${targetName}`);
    setCancelMatchModalOpen(false);
    setMentorToCancel(null);
  };

  /** Calendar modal */
  const handleCalendarOpen = (member: any) => {
    setDisplayName(member.displayName);
    setParticipantUser(member);
    // setPeersOpen(false);
  };

  const navigateToChat = () => {
    let communicationId = _.get(selectedMember, 'communicationUserId', '');
    if (!communicationId) {
      communicationId = _.get(selectedMember, 'communicationId', '');
    }
    const channel = personalThreadsArr?.find((each) => each?.displayNames?.includes(communicationId));
    dispatch(chatProfileActions.atnSetChatProfileState(null));
    if (communicationId && channel) {
      navigate(`/app/chat/?threadid=${_.get(channel, 'id')}&type=Chats&name=${_.get(channel, 'topic')}`);
    } else if (communicationId && !channel) {
      navigate(`/app/chat/?commId=${communicationId}`);
    }
  };

  useEffect(() => {
    if (selectedMember) {
      navigateToChat();
    }
  }, [selectedMember]);

  useEffect(() => {
    if (typeof groupId === 'string' && groupId !== '') {
      queryClient.fetchQuery({
        queryKey: [queryKeys.GET_MENTEE_PEERS, groupId]
      });
      getMenteesInsights();
      queryClient.fetchQuery({
        queryKey: [queryKeys.GET_MY_MENTORS, groupId]
      });
    }
  }, [groupId, reloadFlag]);

  if (groupList.error) {
    return <Box>{groupList.errorText}</Box>;
  }

  if (groupList.data?.length === 0) {
    return <Box>No Groups found</Box>;
  }

  const handleAddLevels = () => {
    dispatch(menteeTaskSlicAction.openDialog({ isOpen: true, mode: 'add' }));
  };
  const handleAddTasks = (level: any) => {
    dispatch(menteeTaskSlicAction.setSelectedLevel({ selectedLevel: level.levelName, selectedLevelId: level._id }));
    dispatch(menteeTaskSlicAction.openDialog({ isOpen: true, mode: 'addTask' }));
  };

  const handleEditLevel = () => {
    dispatch(
      menteeTaskSlicAction.setSelectedLevel({
        selectedLevel: selectedLevelName,
        selectedLevelId: selectedLevelId
      })
    );
    dispatch(menteeTaskSlicAction.openDialog({ isOpen: true, mode: 'edit' }));
    // handleClose();
  };

  const handleDeleteLevel = () => {
    dispatch(
      menteeTaskSlicAction.setSelectedLevel({
        selectedLevelId: selectedLevelId
      })
    );
    dispatch(menteeTaskSlicAction.openDialog({ isOpen: true, mode: 'delete' }));
    // handleClose();
  };
  const currentDate = Date.now() / 1000;

  function getAvailabilityMessage(startDate: any, endDate: any, type: string, dateType?: string) {
    let color = '';
    let text = '';
    if (!startDate && !endDate) {
      text = '';
    } else if (startDate && !endDate) {
      if (currentDate >= startDate) {
        text = '';
      } else {
        text = `Available on ${moment.unix(startDate).format('DD/MM/YYYY')} `;
      }
    } else if (currentDate < startDate) {
      text = `Available on ${moment.unix(startDate).format('DD/MM/YYYY')} `;
    } else if (currentDate >= startDate && currentDate <= endDate) {
      const timeLeft = endDate - currentDate;
      if (timeLeft <= 7 * 24 * 3600) {
        // 7 days in seconds
        color = 'orange';
      } else {
        color = '';
      }
      text = `Due by ${moment.unix(endDate).format('DD/MM/YYYY')}`;
    } else if (currentDate > endDate) {
      color = 'red';
      text = `Due by ${moment.unix(endDate).format('DD/MM/YYYY')}`;
    } else {
      text = '';
    }

    if (type === 'level') {
      return (
        <Typography fontSize={'12px'} fontStyle={'italic'} color={dateType === levelTypes.availableSoon ? '' : color}>
          {dateType === levelTypes.availableSoon ? 'Available soon' : text}
        </Typography>
      );
    }

    return (
      <Typography
        bottom={'-12px'}
        fontSize={'12px'}
        lineHeight={'14px'}
        fontStyle={'italic'}
        position={'absolute'}
        color={color}
      >
        {text}
      </Typography>
    );
  }

  const getIsTaskStarted = (startDate: any) => {
    if (!startDate || currentDate >= startDate) {
      return true;
    }
    return false;
  };

  const getLevelText = (level: any) => {
    if (level?.startDate?.type === levelTypes.availableSoon) {
      return 'soon';
    }
    return `on ${moment.unix(level?.startDate.value).format('DD/MM/YYYY')}`;
  };

  const getPreferredObjectiveIndex = (objs: any[]) => {
    if (!Array.isArray(objs) || objs.length === 0) {
      return 0;
    }
    const inProgressIndex = objs.findIndex((obj) => obj.status === 'inprogress' && obj.objective);
    if (inProgressIndex !== -1) {
      return inProgressIndex;
    }
    const todoIndex = objs.findIndex((obj) => obj.status === 'to-do' && obj.objective);
    if (todoIndex !== -1) {
      return todoIndex;
    }
    return 0;
  };

  useEffect(() => {
    if (!learningObjectives.length) {
      setCurrentObjectiveIndex(0);
      return;
    }

    setCurrentObjectiveIndex((prev) => {
      if (!hasSetObjectiveIndex) {
        return getPreferredObjectiveIndex(learningObjectives);
      }
      if (prev >= learningObjectives.length) {
        return learningObjectives.length - 1;
      }
      return prev;
    });

    if (!hasSetObjectiveIndex) {
      setHasSetObjectiveIndex(true);
    }
  }, [learningObjectives, hasSetObjectiveIndex]);

  useEffect(() => {
    setMentorCardIndex(0);
  }, [currentObjectiveIndex]);

  const getTasks = (each: any) => {
    return (
      <>
        {each?.map((level: any, index: any) => {
          const levelColor = getLevelActiveDate(level) ? 'green' : level.levelColor;
          return (
            <Box className="MylevelsCard">
              <Box
                borderRadius="8px 8px 0 0"
                borderTop={`10px solid ${getBorderColor(levelColor, getLevelActiveDate(level))}`}
              />
              <Box>
                <Box px={2} pt={2} pb={1} display="flex" justifyContent="space-between" alignItems="center">
                  <Box width="calc(100% - 45px)">
                    <Typography color="secondary.light" variant="h6">
                      {getOrfiumLevelName(oid, selectedGroupId?.id, index + 1)}
                    </Typography>
                    <Typography variant="h5" noWrap>
                      {level.levelName}
                    </Typography>
                    {/* Level end date print */}
                    <Box height={'14px'}>
                      {level?.endDate?.value || level?.startDate?.value
                        ? getAvailabilityMessage(
                            level?.startDate?.value,
                            level?.endDate?.value,
                            'level',
                            level?.startDate?.type
                          )
                        : null}
                    </Box>
                  </Box>
                  <img
                    src={getTrophyBadge(level.hexColor, getLevelActiveDate(level))}
                    alt="Trophybadge"
                    width="35px"
                    height="35px"
                  />
                  {!level?.level && (
                    <Box>
                      <MoreVertIcon
                        color="primary"
                        className="cursor-pointer"
                        onClick={(event) => rightTopDotsClick(level)(event)}
                      />
                    </Box>
                  )}
                </Box>

                <Divider />

                {getLevelActiveDate(level) ? (
                  <Box p={2}>
                    {level.tasks.map((task: any, index: number) => {
                      return (
                        <React.Fragment key={task._id}>
                          <Box
                            gap="15px"
                            width={'100%'}
                            display="flex"
                            alignItems="center"
                            onClick={() => {
                              if (getIsTaskStarted(task?.startDate)) {
                                navigate(`/app/home/mentee/level/${level._id}/task/${task._id}`);
                              }
                            }}
                            sx={{
                              cursor: getIsTaskStarted(task?.startDate) ? 'pointer' : 'not-allowed'
                            }}
                          >
                            <img
                              src={task.taskColor === 'green' ? greencheckimg : greycheckimg}
                              alt="greencheckimg"
                              width="20px"
                              height="20px"
                            />
                            <Box flex={1} position={'relative'} width={'calc(100% - 35px)'}>
                              <Typography
                                noWrap
                                className={getIsTaskStarted(task?.startDate) ? 'cursor-pointer' : 'cursor-not-allowed'}
                                color={task.taskColor === 'green' ? 'secondary' : '#0071A9'}
                              >
                                {task.taskName}
                              </Typography>
                              {getAvailabilityMessage(task?.startDate, task?.endDate, 'task')}
                            </Box>
                          </Box>

                          {index !== level.tasks.length - 1 && (
                            <Box borderLeft="1px dotted #D9D9D9" ml="9.5px" py="10px" />
                          )}
                        </React.Fragment>
                      );
                    })}
                  </Box>
                ) : (
                  <Box p={2} mt={2} textAlign={'center'}>
                    {lockIcon({ size: '35px', color: '#68717A' })}
                    <Typography mt={1}>This module will be available {getLevelText(level)}</Typography>
                    <Link
                      color={'info.main'}
                      fontStyle={'italic'}
                      onClick={() => {
                        setLevelNumber(index + 1);
                        setLevelFullName(level?.levelName || 'No module Name');
                        setLevelDescription(level?.levelDescription || 'This module has no description');
                        handleOpenDescription();
                      }}
                    >
                      Read description of Module {index + 1}
                    </Link>
                  </Box>
                )}
              </Box>
              {!level?.level && (level?.startDate?.type === levelTypes.activeNow || level?.startDate === undefined) && (
                <Box pb={2} pl={2}>
                  <Link onClick={() => handleAddTasks(level)} color={'info.main'} variant="caption">
                    + Add Lesson
                  </Link>
                </Box>
              )}
            </Box>
          );
        })}

        {/* edit or delete modal */}
        <Popover
          id={rightTopPopover}
          open={editModalOpen}
          anchorEl={rightTopPop}
          onClose={handleClose}
          anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
          transformOrigin={{ vertical: 'top', horizontal: 'right' }}
        >
          <Box className="PopoverListStyle" gap="8px" onClick={() => handleEditLevel()}>
            <EditIcon />
            <Typography color="primary">Edit Module</Typography>
          </Box>
          <Box className="PopoverListStyle" onClick={() => handleDeleteLevel()} gap="8px">
            <DeleteIcon />
            <Typography color="primary">Delete Module</Typography>
          </Box>
        </Popover>
      </>
    );
  };

  const getLevelActiveDate = (level: any) => {
    if (level?.startDate?.type === levelTypes.activeNow || level?.startDate === undefined) {
      return true;
    }
    if (level?.startDate?.type === levelTypes.availableSoon) {
      return false;
    }

    if (level?.startDate?.type === levelTypes.calendarDate && currentDate >= level?.startDate?.value) {
      return true;
    }
    if (level?.startDate?.type === levelTypes.daysAfterSignup && currentDate >= level?.startDate?.value) {
      return true;
    }
    return false;
  };

  const totalObjectives = learningObjectives.length;
  const displayedObjectiveCount = objectivesNumber || totalObjectives || 0;

  const handleNextObjective = () => {
    if (!totalObjectives) return;
    setCurrentObjectiveIndex((prev) => Math.min(prev + 1, totalObjectives - 1));
  };

  const handlePrevObjective = () => {
    if (!totalObjectives) return;
    setCurrentObjectiveIndex((prev) => Math.max(prev - 1, 0));
  };

  const handleMarkObjectiveComplete = () => {
    const currentObjective = learningObjectives[currentObjectiveIndex];
    if (!currentObjective?.id || markingObjective) return;
    setCompleteModalOpen(true);
  };

  const executeMarkObjectiveComplete = async () => {
    const currentObjective = learningObjectives[currentObjectiveIndex];
    if (!currentObjective?.id || markingObjective) return;
    try {
      setMarkingObjective(true);
      const payload = {
        id: currentObjective.id,
        objective: currentObjective.objective,
        description: currentObjective.description,
        status: 'completed',
        notes: currentObjective.notes || [],
        mentors: currentObjective.mentors || []
      };
      await API.updateMenteeLearningObjectives({ objId: currentObjective.id, data: payload });
      queryClient.invalidateQueries({
        queryKey: [queryKeys.GET_LEARNING_OBJS, groupId]
      });
      await fetchObjectives();
    } catch (error) {
      toast.error(_.get(error, 'response.data.message', 'Unable to update objective status'));
    } finally {
      setMarkingObjective(false);
      setCompleteModalOpen(false);
    }
  };

  const getMentorMeetings = (mentor: any) => {
    const meetings = Array.isArray(mentor?.meetings) ? mentor.meetings : [];
    const now = moment();
    const pastMeetings: any[] = [];
    const futureMeetings: any[] = [];

    meetings.forEach((meeting: any) => {
      const callDetails = meeting?.callDetails || meeting;
      const callDate = callDetails?.callDate ? moment(callDetails.callDate) : null;
      if (callDate && callDate.isValid()) {
        if (callDate.isSameOrAfter(now, 'day')) {
          futureMeetings.push(meeting);
        } else {
          pastMeetings.push(meeting);
        }
      }
    });

    return { pastMeetings, futureMeetings };
  };

  const getMentorStats = (mentor: any) => {
    const { pastMeetings, futureMeetings } = getMentorMeetings(mentor);

    let pastMeetingsCount = pastMeetings.length;
    let upcomingMeetings = futureMeetings.length;

    const messagesShared =
      mentor?.messagesShared ??
      mentor?.totalMessages ??
      mentor?.messagesCount ??
      mentor?.messageCount ??
      (Array.isArray(mentor?.messages) ? mentor.messages.length : 0) ??
      0;

    return {
      messagesShared: messagesShared || 0,
      meetingHistory: pastMeetingsCount,
      futureMeetings: upcomingMeetings
    };
  };

  const getMentorDisplayName = (mentor: any) => {
    const fullName = mentor?.name || mentor?.displayName || getName(mentor);
    if (fullName && typeof fullName === 'string') return fullName;
    return 'Mentor';
  };

  const getMentorObjectiveTitle = (mentor: any) => {
    if (!mentor || !learningObjectives.length) return '';
    const mentorId = mentor?.mid || mentor?.userId || mentor?.id || mentor?.mentorId;
    if (!mentorId) return '';
    const matchedObjective = learningObjectives.find((objective: any) => {
      return (
        Array.isArray(objective?.mentors) &&
        objective.mentors.some((eachMentor: any) => {
          const candidateId = eachMentor?.mid || eachMentor?.userId || eachMentor?.id || eachMentor?.mentorId;
          return candidateId && candidateId === mentorId;
        })
      );
    });
    return matchedObjective?.objective || '';
  };

  const renderMentorStat = (value: number, label: string, highlight = false, onClick?: () => void) => {
    let IconCmp: React.ElementType | null = null;
    if (label.toLowerCase().includes('message')) IconCmp = QuestionAnswerOutlinedIcon;
    else if (label.toLowerCase().includes('history')) IconCmp = RestoreIcon;
    else if (label.toLowerCase().includes('future')) IconCmp = InsertInvitationOutlinedIcon;

    return (
      <Box
        onClick={onClick}
        sx={{
          alignSelf: 'stretch',
          minHeight: 60,
          p: 1.25,
          borderRadius: '10px',
          display: 'flex',
          alignItems: 'center',
          gap: 1.25,
          background: 'var(--Fill-background, #0F0F0F) !important',
          cursor: onClick ? 'pointer' : 'default',
          transition: onClick ? 'transform 0.1s ease-in-out' : undefined,
          '&:hover': onClick
            ? {
                transform: 'translateY(-1px)',
                boxShadow: '0 4px 12px rgba(0,0,0,0.25)'
              }
            : undefined
        }}
      >
        <Box flex={1} display="flex" flexDirection="column" gap={0.5}>
          <Typography sx={{ color: '#FDFDFD', fontSize: 18, fontWeight: 600, lineHeight: '18px' }}>{value}</Typography>
          <Typography sx={{ color: '#868686', fontSize: 14, fontWeight: 600, lineHeight: '14px' }}>{label}</Typography>
        </Box>
        <Box
          sx={{
            width: 40,
            height: 40,
            borderRadius: '999px',
            background: highlight
              ? 'linear-gradient(180deg, #F79420 0%, #F15A26 100%)'
              : 'var(--Fill-Button-button-gray, #1C1C1C)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center'
          }}
        >
          {IconCmp ? (
            <IconCmp sx={{ color: '#FDFDFD', fontSize: 22 }} />
          ) : (
            <Box
              sx={{
                width: 24,
                height: 24,
                border: `2px solid ${highlight ? '#FDFDFD' : '#FDFDFD'}`,
                borderRadius: highlight ? '4px' : '6px'
              }}
            />
          )}
        </Box>
      </Box>
    );
  };

  const renderMentorCard = (mentor: any, index: number) => {
    const mentorName = getMentorDisplayName(mentor);
    const [firstName, ...restName] = mentorName.split(' ');
    const lastName = restName.join(' ');
    const avatar = mentor?.image || mentor?.headshot;
    const stats = getMentorStats(mentor);

    return (
      <Box
        key={mentor?.mid || mentor?.userId || mentor?.id || index}
        sx={{
          width: { xs: '100%', sm: 344 },
          minHeight: 321,
          p: 2.5,
          borderRadius: '6px',
          outline: '1px solid var(--Stroke-Card-card-highlight, #FDFDFD) !important',
          outlineOffset: '-1px',
          background: 'var(--Fill-Card-card-highlight, #1C1C1C) !important',
          display: 'flex',
          flexDirection: 'column',
          gap: 3.75
        }}
      >
        <Box display="flex" alignItems="center" gap={1.25} width="100%">
          <Box
            sx={{
              width: 50,
              height: 50,
              borderRadius: '50%',
              overflow: 'hidden',
              background: '#2A2A2A',
              flexShrink: 0
            }}
            onClick={() => moveToUsercommunityProfile(mentor?.userId)}
          >
            {avatar ? (
              <Box
                component="img"
                src={avatar}
                alt={mentorName}
                sx={{ width: '100%', height: '100%', objectFit: 'cover' }}
              />
            ) : (
              <Box
                sx={{
                  width: '100%',
                  height: '100%',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  color: '#fff',
                  fontWeight: 700,
                  fontSize: 18
                }}
              >
                {mentorName.charAt(0)}
              </Box>
            )}
          </Box>
          <Box flex={1} display="flex" flexDirection="column" gap={0.5} minWidth={0}>
            <Typography sx={{ color: '#B6B6B6', fontSize: 10, fontWeight: 700, lineHeight: '11px' }}>
              {`Mentor ${index + 1}`}
            </Typography>
            <Box display="flex" gap={0.5} alignItems="center" flexWrap="wrap">
              <Typography sx={{ color: '#FDFDFD', fontSize: 18, fontWeight: 600, lineHeight: '18px' }} noWrap>
                {firstName}
              </Typography>
              {lastName && (
                <Typography sx={{ color: '#FDFDFD', fontSize: 18, fontWeight: 600, lineHeight: '18px' }} noWrap>
                  {lastName}
                </Typography>
              )}
            </Box>
          </Box>
          <Box
            sx={{
              width: 24,
              height: 24,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              color: '#FDFDFD'
            }}
            onClick={(e) => handleOpenMentorMenu(e as any, mentor)}
          >
            <MoreVertIcon sx={{ fontSize: 20 }} />
          </Box>
        </Box>

        <Stack spacing={1.5} width="100%">
          {renderMentorStat(stats.messagesShared, 'Messages Shared', true, () => handleViewMentorProfile(mentor))}
          {renderMentorStat(stats.meetingHistory, 'Meeting History', false, () =>
            handleOpenMeetingModal(mentor, 'history')
          )}
          {renderMentorStat(stats.futureMeetings, 'Future Meetings', false, () =>
            handleOpenMeetingModal(mentor, 'future')
          )}
        </Stack>
      </Box>
    );
  };

  const renderMentorshipLayout = () => {
    const currentObjective = learningObjectives[currentObjectiveIndex];
    const mentorsForObjective = currentObjective?.mentors || [];
    const mentorCards = [...(mentorsForObjective || []), { isAddCard: true }];
    const totalMentorCards = mentorCards.length;
    const mentorPrevDisabled = mentorCardIndex <= 0;
    const isOnAddCard = mentorCards[mentorCardIndex]?.isAddCard;
    const mentorNextDisabled = !isOnAddCard && mentorCardIndex >= totalMentorCards - 1;
    const objectiveLabel = totalObjectives ? `Objective ${currentObjectiveIndex + 1}` : 'Objective';
    const isPrevDisabled = currentObjectiveIndex <= 0;
    const isNextDisabled = currentObjectiveIndex >= Math.max(totalObjectives - 1, 0);

    if (objLoading) {
      return (
        <Box p={3}>
          <MySkeleton variant="rounded" height={200} />
        </Box>
      );
    }

    if (!totalObjectives) {
      return (
        <Box p={3} bgcolor="var(--Fill-Table-table-highlight, #151515)" borderRadius={1.25}>
          <Typography variant="h5" color="secondary" mb={1}>
            No objectives found
          </Typography>
          <Typography color="text.secondary">Add your first objective to start matching with mentors.</Typography>
        </Box>
      );
    }

    return (
      <Box
        position="relative"
        p={{ xs: 2, md: 3 }}
        // pb={{ xs: 14, md: 16 }}
        borderRadius={1}
        bgcolor="var(--Fill-Table-table-highlight, #151515)"
        overflow="hidden"
        sx={{ border: '1px solid var(--Stroke-Carousel-button, #2A2A2A)', height: '100%' }}
      >
        <Stack direction={{ xs: 'column', md: 'row' }} spacing={2} alignItems="center">
          <Box flex={1} display="flex" flexDirection="column" gap={0.75} width="100%">
            <Box display="flex" alignItems="center" gap={1.25}>
              <Typography fontSize={14} sx={{ color: 'white' }} fontWeight={400} lineHeight="20px">
                {displayedObjectiveCount ? `${objectiveLabel} of ${displayedObjectiveCount}` : objectiveLabel}
              </Typography>
              {currentObjective?.status === 'completed' && (
                <Box display="flex" alignItems="center" gap={0.5}>
                  <CheckOutlinedIcon
                    sx={{
                      width: 16,
                      height: 16,
                      color: 'var(--UI-Success, #00972D)',
                      border: '1.5px solid var(--UI-Success, #00972D)',
                      borderRadius: '4px',
                      p: 0.3,
                      boxSizing: 'border-box'
                    }}
                  />
                  <Typography fontSize={12} fontWeight={600} color="var(--UI-Success, #00972D)" lineHeight="17px">
                    Completed
                  </Typography>
                </Box>
              )}
            </Box>
            <Typography
              fontSize={26}
              fontWeight={600}
              color={` ${currentObjective?.status === 'completed' ? '#00972D' : '#F79420'}`}
              textTransform="capitalize"
              lineHeight="31px"
              noWrap
            >
              {currentObjective?.objective || 'Add your objective'}
            </Typography>
          </Box>

          <Box
            sx={{
              width: { xs: '100%', md: 400 },
              p: 2,
              background: 'var(--Fill-Card-card-goal-bg, #0F0F0F)',
              borderRadius: 1,
              display: 'flex',
              alignItems: 'flex-start',
              gap: 1.5
            }}
          >
            <FlagOutlinedIcon
              sx={{
                color: 'var(--Stroke-icon-highlight, #FDFDFD)',
                width: 18,
                height: 18,
                mt: 0.25
              }}
            />
            <Typography fontSize={12} fontWeight={700} sx={{ color: 'white' }} lineHeight="18px">
              Your goal is to find a mentor for each objective, message them, and complete at least one meeting with
              each.
            </Typography>
          </Box>
        </Stack>

        <Box mt={3} display="flex" flexDirection="column" gap={2}>
          <Typography fontSize={20} fontWeight={600} sx={{ color: 'white' }}>
            My Mentors for this Objective:
          </Typography>
          <Box
            position="relative"
            display="flex"
            justifyContent="center"
            alignItems="center"
            sx={{ py: { xs: 4, md: 6 } }}
          >
            <Box sx={{ width: { xs: '100%', sm: 360 }, display: 'flex', justifyContent: 'center' }}>
              {mentorCards.length ? (
                mentorCards[mentorCardIndex]?.isAddCard ? (
                  <Box
                    onClick={() => handleRecruitModalOpen(true)}
                    sx={{
                      cursor: 'pointer',
                      width: { xs: '100%', sm: 344 },
                      minHeight: 321,
                      p: 2.5,
                      borderRadius: '6px',
                      outline: '1px solid var(--Stroke-Border-border-dim, #2A2A2A)',
                      outlineOffset: '-1px',
                      display: 'flex',
                      flexDirection: 'column',
                      alignItems: 'center',
                      justifyContent: 'center',
                      gap: 2.5,
                      textAlign: 'center',
                      background: 'transparent'
                    }}
                  >
                    <Typography fontSize={22} fontWeight={600} sx={{ color: 'white' }}>
                      Add Mentor
                    </Typography>
                    <Box
                      sx={{
                        width: 34,
                        height: 34,
                        borderRadius: '50%',
                        background: 'var(--Fill-Button-button-gray, #1C1C1C)',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        border: '1px solid #2A2A2A'
                      }}
                    >
                      <AddIcon sx={{ width: 18, height: 18, color: '#FDFDFD' }} />
                    </Box>
                  </Box>
                ) : (
                  renderMentorCard(mentorCards[mentorCardIndex], mentorCardIndex)
                )
              ) : (
                <Box
                  sx={{
                    width: { xs: '100%', sm: 344 },
                    minHeight: 200,
                    borderRadius: '6px',
                    border: '1px dashed #2A2A2A',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    color: 'text.primary',
                    textAlign: 'center',
                    px: 2
                  }}
                >
                  No mentors yet. Add a mentor to get started.
                </Box>
              )}
            </Box>
          </Box>
        </Box>

        <Box
          sx={{
            position: 'absolute',
            bottom: 24,
            left: '50%',
            transform: 'translateX(-50%)',
            background: 'var(--Fill-tooltip-dim, #2A2A2A)',
            boxShadow: '0px 4px 8px rgba(0, 0, 0, 0.55)',
            borderRadius: '14px',
            display: 'inline-flex',
            alignItems: 'center',
            gap: '9px',
            px: '15px',
            py: '12px',
            // width: 'calc(100% - 48px)',
            maxWidth: 700
          }}
        >
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              gap: '5px',
              borderRadius: '6px',
              cursor: isPrevDisabled ? 'not-allowed' : 'pointer',
              color: 'var(--Text-text-primary, #FDFDFD)',
              opacity: isPrevDisabled ? 0.5 : 1
            }}
            onClick={() => {
              if (isPrevDisabled) return;
              handlePrevObjective();
            }}
          >
            <ArrowBackIcon sx={{ width: 18, height: 18, color: 'var(--Stroke-icon-highlight, #FDFDFD)' }} />
            <Typography fontSize={12} fontWeight={600} color="var(--Text-text-primary, #FDFDFD)">
              Last Objective
            </Typography>
          </Box>

          <Divider
            orientation="vertical"
            flexItem
            sx={{ borderColor: 'var(--Fill-Transparent-trans-contrast-1, rgba(255, 255, 255, 0.10))' }}
          />

          {currentObjective?.status === 'completed' ? (
            <Box
              sx={{
                display: 'flex',
                alignItems: 'center',
                gap: '5px',
                px: '14px',
                py: '10px',
                borderRadius: '6px',
                background: 'var(--Fill-Button-button-basic-disable, rgba(0, 0, 0, 0.20))',
                cursor: 'default'
              }}
            >
              <Typography
                fontSize={13}
                fontWeight={500}
                color="var(--Stroke-Button-button-basic-disabled, #565656)"
                lineHeight="19.5px"
              >
                Objective Completed
              </Typography>
              <CheckCircleOutlineIcon sx={{ width: 18, height: 18, color: '#565656' }} />
            </Box>
          ) : (
            <Box
              onClick={handleMarkObjectiveComplete}
              sx={{
                display: 'flex',
                alignItems: 'center',
                gap: '5px',
                px: '14px',
                py: '10px',
                borderRadius: '6px',
                background: 'linear-gradient(180deg, var(--orange-500, #F79420) 0%, var(--orange-700, #F15A26) 100%)',
                cursor: !currentObjective?.id || markingObjective ? 'not-allowed' : 'pointer',
                opacity: !currentObjective?.id || markingObjective ? 0.7 : 1
              }}
            >
              <Typography
                fontSize={13}
                fontWeight={600}
                color="var(--Stroke-Button-button-cta-default, #FDFDFD)"
                lineHeight="19.5px"
              >
                {markingObjective ? 'Updating...' : 'Mark Objective Complete'}
              </Typography>
              <CheckCircleOutlineIcon
                sx={{ width: 18, height: 18, color: 'var(--Stroke-Button-button-cta-default, #FDFDFD)' }}
              />
            </Box>
          )}

          <Divider
            orientation="vertical"
            flexItem
            sx={{ borderColor: 'var(--Fill-Transparent-trans-contrast-1, rgba(255, 255, 255, 0.10))' }}
          />

          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              gap: '5px',
              borderRadius: '6px',
              cursor: isNextDisabled ? 'not-allowed' : 'pointer',
              color: 'var(--Text-text-primary, #FDFDFD)',
              opacity: isNextDisabled ? 0.5 : 1
            }}
            onClick={() => {
              if (isNextDisabled) return;
              handleNextObjective();
            }}
          >
            <Typography fontSize={12} fontWeight={600} color="var(--Text-text-primary, #FDFDFD)">
              Next Objective
            </Typography>
            <ArrowForwardIcon sx={{ width: 18, height: 18, color: 'var(--Stroke-icon-highlight, #FDFDFD)' }} />
          </Box>
        </Box>

        <IconButton
          disabled={mentorPrevDisabled}
          onClick={() => setMentorCardIndex((prev) => Math.max(prev - 1, 0))}
          sx={{
            position: 'absolute',
            left: 0,
            top: '50%',
            transform: 'translateY(-50%)',
            background: mentorPrevDisabled
              ? 'var(--Fill-Carousel-button-disabled, rgba(0, 0, 0, 0.10))'
              : 'var(--Fill-Carousel-button-default, rgba(0, 0, 0, 0.50))',
            borderRadius: '4px',
            borderTopLeftRadius: 0,
            borderBottomLeftRadius: 0,
            border: '1px solid var(--Stroke-Carousel-button, #2A2A2A)',
            height: '100px',
            width: '44px'
          }}
        >
          <ArrowBackIosNewOutlinedIcon fontSize="small" sx={{ color: mentorPrevDisabled ? '#444' : '#FDFDFD' }} />
        </IconButton>
        <IconButton
          disabled={mentorNextDisabled}
          onClick={() => {
            if (mentorCards[mentorCardIndex]?.isAddCard) {
              handleRecruitModalOpen(true);
              return;
            }
            setMentorCardIndex((prev) => Math.min(prev + 1, totalMentorCards - 1));
          }}
          sx={{
            position: 'absolute',
            right: 0,
            top: '50%',
            transform: 'translateY(-50%)',
            background: 'var(--Fill-Carousel-button-default, rgba(0, 0, 0, 0.50))',
            borderRadius: '4px',
            borderTopRightRadius: 0,
            borderBottomRightRadius: 0,
            border: '1px solid var(--Stroke-Carousel-button, #2A2A2A)',
            height: '100px',
            width: '44px'
          }}
        >
          {mentorCards[mentorCardIndex]?.isAddCard ? (
            <AddIcon fontSize="small" sx={{ color: '#FDFDFD' }} />
          ) : (
            <ArrowForwardIosOutlinedIcon fontSize="small" sx={{ color: '#FDFDFD' }} />
          )}
        </IconButton>
      </Box>
    );
  };

  const meetingFilters = useMemo(() => meetingColor(), []);
  const { type: activeModalType, mentor: activeModalMentor } = activeMeetingModal;
  const activeMeetingGroups = activeModalMentor
    ? getMentorMeetings(activeModalMentor)
    : { pastMeetings: [], futureMeetings: [] };
  const meetingsToShow =
    activeModalType === 'future'
      ? activeMeetingGroups.futureMeetings
      : activeModalType === 'history'
      ? activeMeetingGroups.pastMeetings
      : [];
  const mentorDisplayName = activeModalMentor ? getMentorDisplayName(activeModalMentor) : 'Mentor';
  const meetingModalTitle =
    activeModalType === 'future'
      ? `Future Meetings with ${mentorDisplayName}`
      : activeModalType === 'history'
      ? `Meeting History with ${mentorDisplayName}`
      : '';
  const meetingEmptyMessage =
    activeModalType === 'future'
      ? 'No upcoming meetings scheduled.'
      : activeModalType === 'history'
      ? 'No previous meetings logged yet.'
      : '';
  const objectiveTitle = getMentorObjectiveTitle(activeModalMentor);
  const getCallDateParts = (callRowData: any) => {
    if (!callRowData?.callDate || !callRowData?.callTime || !timezone) {
      return { month: '', day: '', weekday: '' };
    }
    const locale = 'en-US';
    const dateTime = timeZonWiseDateTime(callRowData.callDate.toString(), callRowData.callTime.toString(), timezone);
    return {
      month: dateTime.toLocaleString(locale, { month: 'short' }),
      day: dateTime.getDate().toString(),
      weekday: dateTime.toLocaleString(locale, { weekday: 'short' })
    };
  };

  const getMeetingTimeLabel = (callRowData: any) => {
    if (!callRowData?.callDate || !callRowData?.callTime || !timezone) {
      return '';
    }
    return `${timeZoneWiseTime(
      callRowData.callDate.toString(),
      callRowData.callTime.toString(),
      timezone
    ).toLowerCase()} (${timeZoneAbbreviation(timezone)})`;
  };

  const callWithTitle = (callRow: any) => {
    let reviewModalTitle = '';
    if (callRow?.chatType === 'Chats') {
      reviewModalTitle =
        currentUserId === callRow?.callBookedWith?.id
          ? callRow?.callBookedBy?.displayName
          : callRow?.callBookedWith?.displayName;
    } else {
      reviewModalTitle = callRow?.callBookedWith?.name;
    }
    return reviewModalTitle;
  };

  const getCallStatusData = (callRowData: any) => {
    const matchingParticipant = callRowData?.participantsUser?.find((user: any) => user.mid === currentUserId);
    const joinedParticipantsCount =
      callRowData?.participantsUser?.filter((participant: any) => participant.isCallJoined)?.length || 0;
    const isBookerJoined =
      callRowData?.participantsUser?.some((participant: any) => participant.mid === callRowData?.callBookedBy?.id) ||
      false;
    const callTypeData = checkCallType(
      callRowData?.callStatus,
      callRowData?.callDate,
      callRowData?.callTime,
      callRowData?.callTimeInterval,
      matchingParticipant?.callRejectStatus,
      joinedParticipantsCount,
      isBookerJoined
    );
    const filterMeta =
      meetingFilters.find((meeting) => meeting.color === callTypeData?.color_code) ||
      meetingFilters.find((meeting) => meeting.title === callTypeData?.title) ||
      meetingFilters[0];
    return {
      color: callTypeData?.color_code || filterMeta?.color || '#00972D'
    };
  };

  // eslint-disable-next-line react-hooks/rules-of-hooks
  useEffect(() => {
    if (!Array.isArray(taskData) || taskData.length === 0) return;

    // eslint-disable-next-line prefer-destructuring
    const program = taskData[0];
    if (!program?.levels?.length) return;

    const findFirstTaskByColor = (color: string) => {
      for (const level of program.levels) {
        const levelId = level._id;
        const tasks = level.tasks || [];
        const task = tasks.find((t: any) => t.taskColor === color);
        if (task) {
          return { levelId, taskId: task._id };
        }
      }
      return null;
    };

    const firstGrey = findFirstTaskByColor('grey');
    if (firstGrey) {
      const url = `/app/home/mentee/level/${firstGrey.levelId}/task/${firstGrey.taskId}`;
      navigate(url);
      return;
    }

    const allGreen =
      program.levels.length > 0 &&
      program.levels.every((level: any) => {
        const tasks = level.tasks || [];
        return tasks.length > 0 && tasks.every((task: any) => task.taskColor === 'green');
      });

    if (allGreen) {
      const firstGreen = findFirstTaskByColor('green');
      if (firstGreen) {
        const url = `/app/home/mentee/level/${firstGreen.levelId}/task/${firstGreen.taskId}`;
        navigate(url);
      }
    }
  }, [taskData, navigate]);

  return (
    <>
      <Box className="bodyBoxMentee">
        {isMentorship ? (
          renderMentorshipLayout()
        ) : (
          <Box>
            {/* Task cards */}
            <Box className="CardBox" mb={2}>
              <Box p={2} pb={isMentorship ? 1 : 2} gap="8px" display="flex" alignItems="center" flexWrap={'wrap'}>
                {/* <Typography variant="h5" noWrap>{taskData?.[0]?.goalName}</Typography> */}
                {/* <Typography variant="h5" noWrap>
                {isMentorship ? 'Learning Objectives' : 'My Lessons'}
              </Typography> */}
                {isMentorship ? (
                  <Box display="flex" alignItems="center" width="100%">
                    <Box flex={1} height="1px" bgcolor="secondary.light" />
                    <Typography variant="h5" fontSize={{ sm: '22px' }} px={2} noWrap>
                      My Chosen Program Objectives
                    </Typography>
                    <Box flex={1} height="1px" bgcolor="secondary.light" />
                  </Box>
                ) : (
                  <Typography variant="h5" noWrap>
                    My Lessons
                  </Typography>
                )}
                {goalCount > 0 && !isMentorship && (
                  <Link onClick={handleAddLevels} color="info.main" variant="h6" noWrap>
                    {groupDetails?.data?.includeTask
                      ? groupDetails?.data?.allowEditing
                        ? '+ Add Module'
                        : null
                      : null}
                    {/* <PlusCircleIcon color='blue' />{' '}Add a learning objective  */}
                  </Link>
                )}
                <MenteeTaskPopup setReloadFlag={setReloadFlag} />
              </Box>
              {!isMentorship && <Divider />}

              <TaskCardSection
                taskData={taskData}
                loading={taskLoading}
                objData={{ data: objectives?.data?.data, loading: objLoading, error: objError }}
              />
              {/* {taskLoading ? (
              <GetTasksLoader />
            ) : taskData?.length ? (
              <>
                {taskData?.map((eachLevel: any) => {
                  console.log(taskData, 'taskData');
                  return (
                    <Box
                      px={2}
                      key={eachLevel}
                      pb={forMobile ? (eachLevel?.levels?.length > 1 ? 2 : 0) : eachLevel?.levels?.length > 3 ? 2 : 0}
                    >
                      {eachLevel?.levels.length > 0 ? (
                        // Old Task Card Design
                        //  <Box className="MylevelsCardMain">{getTasks(eachLevel.levels)}</Box>
                        // New Task Card Design
                        <Box className="MylevelsCardMain">
                          {eachLevel.levels.map((level: any) => {
                            const levelColor = getLevelActiveDate(level) ? 'green' : level.levelColor;
                            return level.tasks.map((task: any) => {
                              console.log('levelId', level._id);
                              return (
                                <NewTaskCard
                                  key={task.id}
                                  task={task}
                                  levelName={level.levelName}
                                  levelId={level._id}
                                  borderColor={task.taskColor}
                                  trophyColor={task.taskColor}
                                />
                              );
                            });
                          })}
                        </Box>
                      ) : (
                        <Typography textAlign="center" py={2}>
                          No lesson assigned
                        </Typography>
                      )}
                    </Box>
                  );
                })}
              </>
            ) : (
              <Box p={2}>
                <Typography textAlign="center">No lesson assigned</Typography>
              </Box>
            )} */}
            </Box>

            {/* Cards Section */}
            <Grid container spacing={{ xs: 1, sm: 2 }}>
              {/* My Goal */}
              <Grid item xs={12} md={4} lg={3}>
                <Box className={classess.cardBox} minHeight={forMobile ? 'auto' : '240px'}>
                  <Box p={2}>
                    <Typography variant="h5">{loader ? <MySkeleton width={100} /> : 'My Progress'}</Typography>
                  </Box>
                  <Divider />
                  <Box className="mygoalBox" justifyContent={'center'}>
                    {/* Goal progress chart */}
                    <Box>
                      {loader ? (
                        <MySkeleton variant="circular" height={160} width={160} />
                      ) : isMentorship ? (
                        <Box display="flex" flexDirection="column" justifyContent="space-between" gap={2}>
                          <Box display="flex" justifyContent="space-between" gap={3}>
                            <Box display="flex" gap={2}>
                              <UserIcon color="primary" size={24} />
                              <Typography color="primary">Mentors Engaged</Typography>
                            </Box>
                            <Typography variant="h3" color="secondary">
                              {mentorshipProgress.mentorsEngaged}
                            </Typography>
                          </Box>
                          <Box display="flex" justifyContent="space-between" gap={3}>
                            <Box display="flex" gap={2}>
                              <ChatIcon color="primary" size={24} />
                              <Typography color="primary">Messages Sent</Typography>
                            </Box>
                            <Typography variant="h3" color="secondary">
                              {mentorshipProgress.messagesSent}
                            </Typography>
                          </Box>
                          <Box display="flex" justifyContent="space-between" gap={3}>
                            <Box display="flex" gap={2}>
                              <VideoCallIcon color="primary" size={24} />
                              <Typography color="primary">Meetings Scheduled</Typography>
                            </Box>
                            <Typography variant="h3" color="secondary">
                              {mentorshipProgress.meetingsScheduled}
                            </Typography>
                          </Box>
                        </Box>
                      ) : (
                        <ProgressChart
                          percentage={isMentorship ? Number(objProgress) : goalProgress}
                          avgProgress={peersData?.data?.data[0]?.avgGoalProgress || 0}
                        />
                      )}
                    </Box>
                  </Box>
                </Box>
              </Grid>

              {/* My network */}
              {isMentorship || isHybrid ? (
                <Grid item xs={12} md={8} lg={6}>
                  <Box
                    className={`${classess.cardBox} ${classess.flexColumn}`}
                    minHeight={forMobile ? 'auto' : '240px'}
                  >
                    <Box px={2} display={'flex'} justifyContent={'space-between'} alignItems={'center'}>
                      <Typography variant="h5" className="py-20">
                        {loader ? <MySkeleton width={150} /> : `My ${isMentorship ? mentorRoleText : 'Network'}`}
                      </Typography>
                      {/* {isMentorship && (
                        <IconButton size="small" onClick={() => handleRecruitModalOpen(true)}>
                          <PlusCircleIcon color="primary" size={30} />
                        </IconButton>
                      )} */}
                    </Box>
                    <Divider />
                    <Stack
                      direction={{ xs: 'column', sm: 'row' }}
                      divider={<Divider orientation="vertical" flexItem />}
                      spacing={0}
                      height={'100%'}
                    >
                      {/* My mentor */}
                      <Grid item xs={12} sm={isHybrid ? 6 : 12} width={{ xs: '100%', sm: '50%' }} height={'100%'}>
                        <Box p={isHybrid ? 2 : 0} height={'100%'}>
                          {isHybrid && (
                            <Typography variant="h6" color="secondary">
                              {loader ? <MySkeleton width={150} /> : `My ${mentorRoleText}`}
                            </Typography>
                          )}
                          <MyMentorSection
                            loading={loader}
                            doReload={doReload}
                            myMentorList={loader ? dummyMyMentorsList : mentorsData?.data.data}
                            onMeetingScheduled={handleMeetingScheduled}
                          />
                        </Box>
                      </Grid>

                      {/* Leaderboard */}
                      {isHybrid && (
                        <Grid item xs={12} sm={6} width={{ xs: '100%', sm: '50%' }} height={'100%'}>
                          <Box p={2} height={'100%'}>
                            <Leaderboard data={peersData?.data?.data[0]?.menteeDetails} loader={isLoading} />
                          </Box>
                        </Grid>
                      )}
                    </Stack>
                  </Box>
                </Grid>
              ) : null}

              {/* Leaderboard */}
              {isMasterclass && (
                <Grid item xs={12} md={8} lg={6}>
                  <Leaderboard data={peersData?.data?.data[0]?.menteeDetails} loader={isLoading} />
                </Grid>
              )}

              {/* Getting started card & Your next meeting */}
              <Grid item xs={12} md={4} lg={3}>
                {isMasterclass ? (
                  <GettingStartedCard
                    loading={loader}
                    handleClickGettingStartedModal={handleClickGettingStartedModal}
                    setSelectedStep={setSelectedStep}
                    helpfulTips={helpfulTips}
                    handelOnClickPreviewArticleName={handelOnClickPreviewArticleName}
                  />
                ) : (
                  <YourNextMetting
                    loading={loader}
                    newScheduledMeeting={recentlyScheduledMeeting}
                    update={updateMeeting}
                  />
                )}
              </Grid>
            </Grid>
          </Box>
        )}
      </Box>

      <Popover
        open={Boolean(mentorMenuAnchor)}
        anchorEl={mentorMenuAnchor}
        onClose={handleCloseMentorMenu}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
        transformOrigin={{ vertical: 'top', horizontal: 'right' }}
        PaperProps={{
          sx: {
            p: 0,
            background: 'var(--Fill-background, #0F0F0F)',
            borderRadius: '5px',
            outline: '1px solid var(--Stroke-Border-border, #444444)',
            outlineOffset: '-1px'
          }
        }}
      >
        <Box
          sx={{
            width: 200,
            p: '10px 15px',
            display: 'flex',
            flexDirection: 'column',
            gap: '7px'
          }}
        >
          <Box
            onClick={handleViewMentorProfile}
            sx={{
              borderRadius: '6px',
              display: 'inline-flex',
              alignItems: 'center',
              gap: '5px',
              cursor: 'pointer'
            }}
          >
            <Typography sx={{ color: 'var(--Text-text-primary, #FDFDFD)', fontSize: 12, fontWeight: 600 }}>
              View Mentor Profile
            </Typography>
          </Box>
          <Box
            onClick={handleCancelMatchClick}
            sx={{
              borderRadius: '6px',
              display: 'inline-flex',
              alignItems: 'center',
              gap: '5px',
              cursor: 'pointer'
            }}
          >
            <Typography sx={{ color: 'var(--UI-Error, #FF0000)', fontSize: 12, fontWeight: 600 }}>
              Cancel Match
            </Typography>
          </Box>
        </Box>
      </Popover>

      <Modal open={completeModalOpen} onClose={() => (!markingObjective ? setCompleteModalOpen(false) : null)}>
        <Box
          sx={{
            width: 550,
            bgcolor: 'var(--Fill-Modal-background, #0F0F0F)',
            borderRadius: 2,
            outline: '1px solid var(--Stroke-Modal-border, #444444)',
            outlineOffset: '-1px',
            overflow: 'hidden',
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)'
          }}
        >
          <Box
            sx={{
              width: '100%',
              px: 3,
              pr: 5,
              py: 2.5,
              borderBottom: '1px solid var(--Stroke-Border-border-dim, #2A2A2A)',
              display: 'flex',
              alignItems: 'center',
              gap: 2.5,
              position: 'relative'
            }}
          >
            <Typography sx={{ color: '#FDFDFD', fontSize: 18, fontWeight: 700, flex: 1 }}>
              Complete Objective
            </Typography>
            <IconButton
              size="small"
              onClick={() => (!markingObjective ? setCompleteModalOpen(false) : null)}
              sx={{ position: 'absolute', right: 18, top: 18, color: '#FDFDFD' }}
            >
              <Box
                sx={{
                  width: 11,
                  height: 11,
                  outline: '2px solid var(--Stroke-icon-highlight, #FDFDFD)',
                  outlineOffset: '-1px'
                }}
              />
            </IconButton>
          </Box>
          <Box
            sx={{
              p: 3,
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              gap: 3.75
            }}
          >
            <Typography
              sx={{
                color: 'var(--Text-text-secondary, #B6B6B6)',
                fontSize: 14,
                fontWeight: 500,
                lineHeight: '19.88px',
                textAlign: 'center'
              }}
            >
              Objectives are a fundamental part of your program. Make sure you’ve completed{' '}
              <Typography component="span" sx={{ fontWeight: 700, color: 'var(--Text-text-secondary, #B6B6B6)' }}>
                at least 1 Mentorship Program meeting
              </Typography>{' '}
              on this objective before you proceed to mark it as complete.
            </Typography>
            <Box display="flex" gap={1.5} width="100%" justifyContent="center">
              <Button
                fullWidth
                onClick={() => setCompleteModalOpen(false)}
                sx={{
                  px: 1.75,
                  py: 1.25,
                  background: 'var(--Fill-Button-button-basic-default, #1C1C1C)',
                  borderRadius: '6px',
                  color: 'var(--Stroke-Button-button-basic-default, #FDFDFD)',
                  fontSize: 13,
                  fontWeight: 500,
                  textTransform: 'none'
                }}
              >
                Cancel
              </Button>
              <Button
                fullWidth
                disabled={markingObjective}
                onClick={executeMarkObjectiveComplete}
                sx={{
                  px: 1.75,
                  py: 1.25,
                  background: 'linear-gradient(180deg, #F79420 0%, #F15A26 100%)',
                  borderRadius: '6px',
                  color: 'var(--Stroke-Button-button-cta-default, #FDFDFD)',
                  fontSize: 13,
                  fontWeight: 600,
                  textTransform: 'none'
                }}
              >
                {markingObjective ? 'Updating...' : 'Mark as complete'}
              </Button>
            </Box>
          </Box>
        </Box>
      </Modal>

      <Modal open={cancelMatchModalOpen} onClose={() => setCancelMatchModalOpen(false)}>
        <Box
          sx={{
            width: 550,
            bgcolor: 'var(--Fill-Modal-background, #0F0F0F)',
            borderRadius: 2,
            outline: '1px solid var(--Stroke-Modal-border, #444444)',
            outlineOffset: '-1px',
            overflow: 'hidden',
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)'
          }}
        >
          <Box
            sx={{
              width: '100%',
              px: 3,
              pr: 5,
              py: 2.5,
              borderBottom: '1px solid var(--Stroke-Border-border-dim, #2A2A2A)',
              display: 'flex',
              alignItems: 'center',
              gap: 2.5,
              position: 'relative'
            }}
          >
            <Typography sx={{ color: '#FDFDFD', fontSize: 18, fontWeight: 700, flex: 1 }}>Cancel Match?</Typography>
            <IconButton
              size="small"
              onClick={() => setCancelMatchModalOpen(false)}
              sx={{ position: 'absolute', right: 18, top: 18, color: '#FDFDFD' }}
            >
              <Box
                sx={{
                  width: 11,
                  height: 11,
                  outline: '2px solid var(--Stroke-icon-highlight, #FDFDFD)',
                  outlineOffset: '-1px'
                }}
              />
            </IconButton>
          </Box>
          <Box
            sx={{
              p: 3,
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              gap: 3.75
            }}
          >
            <Typography
              sx={{
                color: 'var(--Text-text-secondary, #B6B6B6)',
                fontSize: 14,
                fontWeight: 500,
                lineHeight: '19.88px',
                textAlign: 'center'
              }}
            >
              Are you sure you want to cancel the match with your tutor?
            </Typography>
            <Box display="flex" gap={1.5} width="100%" justifyContent="center">
              <Button
                fullWidth
                onClick={() => setCancelMatchModalOpen(false)}
                sx={{
                  px: 1.75,
                  py: 1.25,
                  background: 'var(--Fill-Button-button-basic-default, #1C1C1C)',
                  borderRadius: '6px',
                  color: 'var(--Stroke-Button-button-basic-default, #FDFDFD)',
                  fontSize: 13,
                  fontWeight: 500,
                  textTransform: 'none'
                }}
              >
                Cancel
              </Button>
              <Button
                fullWidth
                onClick={handleConfirmCancelMatch}
                sx={{
                  px: 1.75,
                  py: 1.25,
                  background: 'var(--Fill-Button-button-cta-disabled, #F15A26)',
                  borderRadius: '6px',
                  color: 'var(--Stroke-Button-button-cta-disabled, #0F0F0F)',
                  fontSize: 13,
                  fontWeight: 600,
                  textTransform: 'none',
                  opacity: 0.7
                }}
              >
                Cancel Match
              </Button>
            </Box>
          </Box>
        </Box>
      </Modal>

      <Modal open={Boolean(activeMeetingModal.type)} onClose={handleCloseMeetingModal}>
        {activeModalType === 'future' ? (
          <Box
            sx={{
              width: { xs: '90vw', sm: 520, md: 600 },
              maxHeight: '90vh',
              bgcolor: 'var(--Fill-Modal-background, #0F0F0F)',
              borderRadius: 2,
              outline: '1px solid var(--Stroke-Modal-border, #444444)',
              outlineOffset: '-1px',
              overflow: 'hidden',
              position: 'absolute',
              top: '50%',
              left: '50%',
              transform: 'translate(-50%, -50%)',
              display: 'flex',
              flexDirection: 'column'
            }}
          >
            <Box
              sx={{
                alignSelf: 'stretch',
                paddingTop: 2.5,
                paddingBottom: 2.5,
                paddingLeft: 3,
                paddingRight: 4,
                borderBottom: '1px solid var(--Stroke-Border-border-dim, #2A2A2A)',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between'
              }}
            >
              <Typography sx={{ color: '#FDFDFD', fontSize: 18, fontWeight: 700 }}>
                {meetingModalTitle || 'Meetings'}
              </Typography>
              <IconButton size="small" onClick={handleCloseMeetingModal} sx={{ color: '#FDFDFD' }}>
                <CloseIcon />
              </IconButton>
            </Box>

            <Box
              sx={{
                alignSelf: 'stretch',
                padding: 3,
                overflow: 'hidden',
                flexDirection: 'column',
                justifyContent: 'flex-start',
                alignItems: 'flex-start',
                gap: 3,
                display: 'flex',
                maxHeight: 'calc(90vh - 120px)',
                overflowY: 'auto'
              }}
            >
              <Box
                sx={{
                  alignSelf: 'stretch',
                  justifyContent: 'flex-start',
                  alignItems: 'flex-start',
                  gap: 1,
                  display: 'flex',
                  flexDirection: 'column'
                }}
              >
                <Typography sx={{ color: 'var(--Text-text-primary, #FDFDFD)', fontSize: 14, fontWeight: 400 }}>
                  Learning Objective
                </Typography>
                <Typography sx={{ color: 'var(--Stroke-highlight, #F79420)', fontSize: 16, fontWeight: 700 }}>
                  {objectiveTitle || 'Objective details coming soon'}
                </Typography>
              </Box>

              {meetingsToShow.length ? (
                meetingsToShow.map((item: any) => {
                  const { month, day, weekday } = getCallDateParts(item);
                  const statusData = getCallStatusData(item);
                  const meetingTimeLabel = getMeetingTimeLabel(item);
                  const durationLabel =
                    typeof item?.callTimeInterval === 'number'
                      ? formattedTimeSlot(item.callTimeInterval).toLowerCase()
                      : '';
                  const attendeeLabel = callWithTitle(item);
                  const handleDetailsClick = () => {};

                  return (
                    <Box className="CallsTableBox" key={item?._id} data-testid="calendar-event">
                      <Box className="MeetingCard">
                        <Box className="MeetingCardMain" onClick={handleDetailsClick}>
                          <Box className="MeetingCardDate">
                            <Box className="MeetingCardDateMonth" sx={{ backgroundColor: statusData.color }}>
                              <Typography sx={{ color: 'white' }}>{month}</Typography>
                            </Box>
                            <Box className="MeetingCardDateDay">
                              <Typography className="MeetingCardDateNumber">{day}</Typography>
                              <Typography className="MeetingCardDateWeekday">{weekday}</Typography>
                            </Box>
                          </Box>
                          <Box className="MeetingCardDetails">
                            <Typography variant="h5" className="MeetingCardTitle">
                              {item?.callTitle}
                            </Typography>
                            <Box className="MeetingCardMeta">
                              {meetingTimeLabel && (
                                <Box className="MeetingCardMetaItem">
                                  <AccessTimeIcon className="MeetingCardMetaClock" fontSize="inherit" />
                                  <Typography className="MeetingCardMetaText">{meetingTimeLabel}</Typography>
                                </Box>
                              )}
                              {durationLabel && (
                                <>
                                  <span className="MeetingCardMetaDivider" />
                                  <Typography className="MeetingCardMetaText">{durationLabel}</Typography>
                                </>
                              )}
                              {attendeeLabel && (
                                <>
                                  <span className="MeetingCardMetaDivider" />
                                  <Typography className="MeetingCardMetaText">{attendeeLabel}</Typography>
                                </>
                              )}
                            </Box>
                          </Box>
                        </Box>
                        <Box className="MeetingCardCtas">
                          <Button
                            variant="contained"
                            color="primary"
                            className="MeetingCardDetailsBtn"
                            onClick={handleDetailsClick}
                          >
                            Details
                          </Button>
                        </Box>
                      </Box>
                    </Box>
                  );
                })
              ) : (
                <Typography sx={{ color: '#B6B6B6', fontSize: 14, textAlign: 'center', width: '100%' }}>
                  {meetingEmptyMessage || 'No meetings yet.'}
                </Typography>
              )}
            </Box>
          </Box>
        ) : (
          <Box
            sx={{
              width: { xs: '90vw', sm: 520, md: 600 },
              maxHeight: '90vh',
              bgcolor: 'var(--Fill-Modal-background, #0F0F0F)',
              borderRadius: 2,
              outline: '1px solid var(--Stroke-Modal-border, #444444)',
              outlineOffset: '-1px',
              overflow: 'hidden',
              position: 'absolute',
              top: '50%',
              left: '50%',
              transform: 'translate(-50%, -50%)',
              display: 'flex',
              flexDirection: 'column'
            }}
          >
            <Box
              sx={{
                width: '100%',
                px: 3,
                pr: 4,
                py: 2.5,
                borderBottom: '1px solid var(--Stroke-Border-border-dim, #2A2A2A)',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between'
              }}
            >
              <Typography sx={{ color: '#FDFDFD', fontSize: 18, fontWeight: 700 }}>
                {meetingModalTitle || 'Meetings'}
              </Typography>
              <IconButton size="small" onClick={handleCloseMeetingModal} sx={{ color: '#FDFDFD' }}>
                <CloseIcon />
              </IconButton>
            </Box>

            <Box
              sx={{
                display: 'flex',
                flexDirection: 'column',
                gap: 2,
                px: 3,
                py: 2,
                overflowY: 'auto'
              }}
            >
              {meetingsToShow.length ? (
                meetingsToShow.map((meeting: any, index: number) => (
                  <Box key={meeting?.meetingId || meeting?.callId || index}>
                    <MeetingDetails
                      meeting={meeting}
                      index={index + 1}
                      menteeName={mentorDisplayName}
                      myMenteesList={activeModalMentor}
                      menteeData={{ name: mentorDisplayName }}
                    />
                  </Box>
                ))
              ) : (
                <Typography sx={{ color: '#B6B6B6', fontSize: 14, textAlign: 'center' }}>
                  {meetingEmptyMessage || 'No meetings yet.'}
                </Typography>
              )}
            </Box>
          </Box>
        )}
      </Modal>

      {/* Group of Peers Modal */}
      {isPeersPopupOpen && (
        <UserPeersPopup
          open={isPeersPopupOpen}
          onClose={() => handlePeersPopup(false)}
          peersList={peersData?.data.data[0]?.menteeDetails}
          onProfileClick={(mid) => moveToUsercommunityProfile(mid)}
          onChatClick={(each) => navigateMember(each)}
          onCalendarClick={(each) => handleCalendarOpen(each)}
          communityMembers={communityMembers} // Pass the communityMembers prop here
          navigate={navigate} // Pass the navigate prop here
        />
      )}

      {/* Check in with Mentor Modal */}
      {/* <CheckInWithMentorDialog
        checkInWithMentor={checkInWithMentor}
        handleCheckInWithMentor={handleCheckInWithMentor}
      /> */}

      {/* Description Modal */}
      <DescriptionModal
        open={isModalOpen}
        onClose={handleCloseModal}
        // title={`Module ${levelNumber} Description`}
        title={`${levelFullName}`}
        message={levelDescription}
      />

      {/* Preview content for Getting Started */}
      <PreviewContent
        openPreview={openPreview}
        setOpenPreview={setOpenPreview}
        singleListData={articleData}
        loading={articleDataLoading}
      />

      {/* Recruit New Mentor */}
      {recruitModalOpen && (
        <RecruitNewMentor
          title=""
          open={recruitModalOpen}
          onClose={() => setRecruitModalOpen(false)}
          mentorsList={recruitMentors}
          onProfileClick={(mid: any) => moveToUsercommunityProfile(mid)}
          onChatClick={(each: any) => navigateMember(each)}
          onCalendarClick={(each: any) => handleCalendarOpen(each)}
          objId=""
          grpId={groupId}
          apiType="all"
          learningObjective={learningObjectives[currentObjectiveIndex]}
        />
      )}

      {/* Getting Started Modal */}
      {/* <GettingStartedModal
        open={openGettingStartedModal}
        handleClickGettingStartedModal={handleClickGettingStartedModal}
        allowEditing={groupDetails?.data?.includeTask && groupDetails?.data?.allowEditing ? true : false}
        selectedStep={selectedStep}
      /> */}

      {/* Welcome Modals */}
      {/* <WelcomeModals open={openGettingStartedModal} handleClickWelcomeModals={handleClickGettingStartedModal} /> */}
    </>
  );
};

export default Mentee;
